import axios from 'axios';

const messageActions = (dispatch) => {
  return {
    loadMessageList: (type, id, channel, onlyUpdate = false) => {
      onlyUpdate
        ? dispatch({ type: 'MESSAGE_LIST_UPDATE' })
        : dispatch({ type: 'MESSAGE_LIST_LOAD' });
      const url =
        type === 'room'
          ? `/api/visitor/rooms/${id}/messages?channel=${channel}`
          : `/api/visitor/events/${id}/messages?channel=${channel}`;
      axios
        .get(url)
        .then((response) => {
          if (response.data) {
            dispatch({
              type: 'MESSAGE_LIST_SUCCESS',
              messageList: response.data,
            });
          } else {
            dispatch({
              type: 'MESSAGE_LIST_ERROR',
              error: 'Wrong list format',
            });
          }
        })
        .catch((error) => {
          console.log(error);
          dispatch({
            type: 'MESSAGE_LIST_ERROR',
            error: 'Could not load messages',
          });
        });
    },
    postMessage: (type, id, channel, data, cb) => {
      dispatch({ type: 'MESSAGE_POST_LOAD', post: data });
      const url =
        type === 'room'
          ? `/api/visitor/rooms/${id}/newchatmessage?channel=${channel}`
          : `/api/visitor/events/${id}/newchatmessage?channel=${channel}`;

      axios
        .post(url, data)
        .then((response) => {
          if (response.data) {
            cb && cb(response.data);
          } else {
            dispatch({ type: 'MESSAGE_POST_ERROR', error: 'Wrong format' });
          }
        })
        .catch(() => {
          dispatch({
            type: 'MESSAGE_POST_ERROR',
            error: 'Could not load messages',
          });
        });
    },
    moderateMessageToAsk: (messageId, cb) => {
      axios
        .put(`/api/visitor/messages/${messageId}/sendtoask`)
        .then((response) => {
          if (response.data) {
            cb && cb();
          }
        })
        .catch(() => {});
    },

    moderateMessage: (messageId, isMine, cb) => {
      dispatch({ type: 'MESSAGE_MODERATE', messageId: messageId });
      axios
        .put(
          `/api/visitor/messages/${messageId}/${
            isMine ? 'remove' : 'moderate'
          }`,
          {}
        )
        .then((response) => {
          if (response.data) {
            // Wait for socket
            //dispatch({type: 'MESSAGE_MODERATE_SUCCESS', post: response.data});
            cb && cb(response.data);
          } else {
            dispatch({ type: 'MESSAGE_POST_ERROR', error: 'Wrong format' });
          }
        })
        .catch(() => {
          dispatch({
            type: 'MESSAGE_POST_ERROR',
            error: 'Could not load messages',
          });
        });
    },
    bannUser: (messageId) => {
      dispatch({ type: 'MESSAGE_MODERATE', messageId: messageId });
      axios
        .put(`/api/visitor/messages/${messageId}`, {})
        .then((response) => {
          if (response.data) {
            // Wait for socket
            //dispatch({type: 'MESSAGE_MODERATE_SUCCESS', post: response.data});
          } else {
            dispatch({ type: 'MESSAGE_POST_ERROR', error: 'Wrong format' });
          }
        })
        .catch(() => {
          dispatch({
            type: 'MESSAGE_POST_ERROR',
            error: 'Could not load messages',
          });
        });
    },
  };
};
export default messageActions;
